import { render, staticRenderFns } from "./SetUsername.vue?vue&type=template&id=6b3f21f0&"
import script from "./SetUsername.vue?vue&type=script&lang=js&"
export * from "./SetUsername.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports